var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<tr>\n    <td class="ct_tpdtopright">'+
((__t=( quote.symbol ))==null?'':__t)+
'</td>\n    <td class="ct_tpdtopright">'+
((__t=( quote.bid ))==null?'':__t)+
'</td>\n    <td class="ct_tpdtopright">'+
((__t=( quote.ask ))==null?'':__t)+
'</td>\n    <td class="ct_tpdtopright">'+
((__t=( quote.spread ))==null?'':__t)+
'</td>\n    <td class="ct_tpdtopright">'+
((__t=( quote.swap.long ))==null?'':__t)+
'</td>\n    <td class="ct_tpdtopright">'+
((__t=( quote.swap.short ))==null?'':__t)+
'</td>\n    <td class="ct_tbdtop">'+
((__t=( quote.swap.currency ))==null?'':__t)+
'</td>\n</tr>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/templates/w/trading/quote_list_item.html
// module id = 56
// module chunks = 0